import { createContext, useContext, useEffect, useState, useCallback, ReactNode } from "react";
import { buscarConfig } from "../api/config";

const NOME_PADRAO = "Painel de Campanha";

interface ConfigValue {
  nomeApp: string;
  faviconPath: string | null;
  logoPath: string | null;
  loading: boolean;
  refresh: () => Promise<void>;
}

const ConfigContext = createContext<ConfigValue | null>(null);

export function ConfigProvider({ children }: { children: ReactNode }) {
  const [nomeApp, setNomeApp] = useState(NOME_PADRAO);
  const [faviconPath, setFaviconPath] = useState<string | null>(null);
  const [logoPath, setLogoPath] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const carregar = useCallback(async () => {
    try {
      const data = await buscarConfig();
      setNomeApp(data.nomeApp || NOME_PADRAO);
      setFaviconPath(data.faviconPath || null);
      setLogoPath(data.logoPath || null);
    } catch {
      // backend fora do ar ou erro de rede — mantém os valores padrão
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    carregar();
  }, [carregar]);

  // Aplica globalmente: título da aba e favicon, independente de qual página está aberta.
  useEffect(() => {
    document.title = nomeApp;
    const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (link) link.href = faviconPath || "/favicon.ico";
  }, [nomeApp, faviconPath]);

  return (
    <ConfigContext.Provider value={{ nomeApp, faviconPath, logoPath, loading, refresh: carregar }}>
      {children}
    </ConfigContext.Provider>
  );
}

export function useConfig() {
  const ctx = useContext(ConfigContext);
  if (!ctx) throw new Error("useConfig precisa estar dentro de <ConfigProvider>");
  return ctx;
}
